export { default as PixIcon } from './pix-v2.svg';
